import NextImage from "next/image";
import { Box, Text } from "@chakra-ui/react";
import PageTitle from "./PageTitle";
import { EmailIcon } from "@chakra-ui/icons";
const CmsPageTitle = ({title, contactEmail}) => {
  return <Box className="footer-wrapper text-white faq-header-wrap">
        <PageTitle className="heading-color" contactEmail={contactEmail}>{title}</PageTitle>
      
    </Box>;
};
export default CmsPageTitle;
